import React from 'react';

const styles = {
  page: {
    width: '210mm',
    height: '297mm',
    background: 'white',
    position: 'relative',
    padding: '32px',
    fontFamily: 'Arial, sans-serif',
    fontSize: '12px',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: '8px',
  },
  logoWrap: { width: '120px' },
  logo: { height: '64px', objectFit: 'contain' },
  banner: {
    background: 'linear-gradient(to right, #9ca3af, #6b7280, #22c55e)',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '12px 0 0 12px',
  },
  bannerTitle: { fontSize: '18px', fontWeight: 700 },
  bannerText: { fontSize: '12px', marginTop: '4px' },
  sectionBox: {
    border: '2px solid #000',
    marginBottom: '18px',
  },
  sectionHeader: {
    background: '#f3f4f6',
    padding: '6px 10px',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontWeight: 700,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '11px',
  },
  th: {
    border: '1px solid #000',
    padding: '6px 8px',
    fontWeight: 700,
  },
  td: {
    border: '1px solid #000',
    padding: '6px 8px',
  },
  rowLabel: {
    borderRight: '1px solid #000',
    fontWeight: 600,
    width: '35%',
    verticalAlign: 'top',
  },
  rowValue: {
    verticalAlign: 'top',
    whiteSpace: 'pre-line',
  },
  subBox: {
    border: '2px solid #000',
    borderCollapse: 'collapse',
    width: '100%',
    marginBottom: '18px',
  },
  footer: {
    position: 'absolute',
    bottom: '16px',
    left: 0,
    right: 0,
    padding: '0 32px',
    fontSize: '10px',
    color: '#6b7280',
  },
  footerLine: {
    borderTop: '1px solid #cbd5e1',
    paddingTop: '6px',
    textAlign: 'center',
  },
  footerRight: {
    textAlign: 'right',
    marginTop: '4px',
  },
};

export default function Page2CaracteristiquesSuite({ rapport, client, parametres }) {
  const p = parametres || {};
  const c = client || {};
  const r = rapport || {};
  const etape1 = r.etape_1_infos_generales_levage || {};
  const etape2 = r.etape_2_caracteristiques_techniques_levage || {};
  const etape5 = r.etape_5_documentation_essais_levage || {};
  const documentsData = etape5.documents || {};

  let codeAnnexe = etape1.famille_machine_code;
  if (!codeAnnexe && etape1.famille_machine_nom) {
    const match = etape1.famille_machine_nom.match(/^(B\d+|C\d+|D\d+)/);
    if (match) codeAnnexe = match[1];
  }
  if (!codeAnnexe) codeAnnexe = 'B5';

  const formatEquipements = (etape2Data) => {
    const securite = etape2Data.equipements_securite || [];
    const complementaires = etape2Data.equipements_complementaires || [];
    const tous = [...securite, ...complementaires];
    return tous.length > 0 ? tous.join('\n') : '';
  };

  const getEnergies = () => {
    switch (codeAnnexe) {
      case 'B1': return 'Électrique';
      case 'B2': return 'Électrique';
      case 'B3': return 'Diesel';
      case 'B4': return 'Électrique / Hydraulique';
      case 'B6': return 'Électrique / Diesel';
      case 'B7': return 'Hydraulique';
      case 'B8': return 'Électrique';
      case 'B10': return 'Manuel';
      case 'B11': return 'Diesel / Électrique';
      case 'C1': return etape2.materiau || '';
      default: return '';
    }
  };

  const buildCaracteristiques = () => {
    const caractList = [];
    switch (codeAnnexe) {
      case 'B1':
        if (etape2.cmu) caractList.push({ label: "CMU - Charge Max d'Utilisation", valeur: `${etape2.cmu} kg` });
        if (etape2.portee) caractList.push({ label: 'Portée', valeur: `${etape2.portee} m` });
        if (etape2.hauteur_levee) caractList.push({ label: 'Hauteur de levée', valeur: `${etape2.hauteur_levee} m` });
        if (etape2.type_alimentation) caractList.push({ label: "Type d'alimentation", valeur: etape2.type_alimentation });
        break;
      case 'B2':
        if (etape2.cmu_max) caractList.push({ label: 'CMU maximale', valeur: `${etape2.cmu_max} kg` });
        if (etape2.portee_max) caractList.push({ label: 'Portée maximale', valeur: `${etape2.portee_max} m` });
        if (etape2.hauteur_crochet) caractList.push({ label: 'Hauteur sous crochet', valeur: `${etape2.hauteur_crochet} m` });
        if (etape2.type_montage) caractList.push({ label: 'Type de montage', valeur: etape2.type_montage });
        break;
      case 'B3':
        if (etape2.capacite_levage) caractList.push({ label: 'Capacité de levage', valeur: `${etape2.capacite_levage} tonnes` });
        if (etape2.longueur_fleche) caractList.push({ label: 'Longueur de flèche', valeur: `${etape2.longueur_fleche} m` });
        if (etape2.type_fleche) caractList.push({ label: 'Type de flèche', valeur: etape2.type_fleche });
        if (etape2.type_stabilisation) caractList.push({ label: 'Type de stabilisation', valeur: etape2.type_stabilisation });
        break;
      case 'B4':
        if (etape2.capacite_max) caractList.push({ label: 'Capacité maximale', valeur: `${etape2.capacite_max} kg` });
        if (etape2.hauteur_levee) caractList.push({ label: 'Hauteur de levée', valeur: `${etape2.hauteur_levee} m` });
        if (etape2.type_pont) caractList.push({ label: 'Type de pont', valeur: etape2.type_pont });
        break;
      case 'B5':
        if (etape2.capacite_nominale) caractList.push({ label: 'Capacité nominale', valeur: `${etape2.capacite_nominale} kg` });
        if (etape2.hauteur_levee) caractList.push({ label: 'Hauteur de levée', valeur: `${etape2.hauteur_levee} m` });
        if (etape2.type_energie) caractList.push({ label: "Type d'énergie", valeur: etape2.type_energie });
        if (etape2.types_mat && etape2.types_mat.length > 0) {
          const matsFormates = etape2.types_mat.map(m => (m === 'simple' ? 'Simple' : m === 'double' ? 'Double' : m === 'triple' ? 'Triple' : m)).join(', ');
          caractList.push({ label: 'Mât', valeur: matsFormates });
        }
        if (etape2.types_chaines && etape2.types_chaines.length > 0) {
          const chainesFormatees = etape2.types_chaines.map(ch => (ch === 'mailles_jointives' ? 'Chaînes à mailles jointives' : ch === 'rouleaux' ? 'Chaînes à rouleaux' : ch)).join(', ');
          caractList.push({ label: 'Chaînes', valeur: chainesFormatees });
        }
        if (etape2.type_chaines_select) {
          caractList.push({ label: 'Type de chaînes (description)', valeur: etape2.type_chaines_select });
        }
        break;
      case 'B6':
        if (etape2.hauteur_travail) caractList.push({ label: 'Hauteur de travail', valeur: `${etape2.hauteur_travail} m` });
        if (etape2.capacite_plateforme) caractList.push({ label: 'Capacité plate-forme', valeur: `${etape2.capacite_plateforme} kg` });
        if (etape2.portee_horizontale) caractList.push({ label: 'Portée horizontale', valeur: `${etape2.portee_horizontale} m` });
        if (etape2.type_pemp) caractList.push({ label: 'Type de PEMP', valeur: etape2.type_pemp });
        break;
      case 'B7':
        if (etape2.capacite_max) caractList.push({ label: 'Capacité maximale', valeur: `${etape2.capacite_max} kg` });
        if (etape2.course_levee) caractList.push({ label: 'Course de levée', valeur: `${etape2.course_levee} m` });
        if (etape2.dimensions_plateforme) caractList.push({ label: 'Dimensions plate-forme', valeur: etape2.dimensions_plateforme });
        break;
      case 'C1':
        if (etape2.cmu) caractList.push({ label: 'CMU', valeur: `${etape2.cmu} kg` });
        if (etape2.longueur) caractList.push({ label: 'Longueur', valeur: `${etape2.longueur} m` });
        if (etape2.nombre_brins) caractList.push({ label: 'Nombre de brins', valeur: etape2.nombre_brins });
        if (etape2.materiau) caractList.push({ label: 'Matériau', valeur: etape2.materiau });
        break;
      case 'B8':
        if (etape2.capacite_max) caractList.push({ label: 'Capacité maximale', valeur: `${etape2.capacite_max} kg` });
        if (etape2.hauteur_levee) caractList.push({ label: 'Hauteur de levée', valeur: `${etape2.hauteur_levee} m` });
        break;
      case 'B9':
        if (etape2.capacite) caractList.push({ label: 'Capacité', valeur: `${etape2.capacite} kg` });
        break;
      case 'B10':
        if (etape2.cmu) caractList.push({ label: 'CMU', valeur: `${etape2.cmu} kg` });
        break;
      case 'B11':
        if (etape2.capacite) caractList.push({ label: 'Capacité', valeur: `${etape2.capacite} kg` });
        break;
      case 'D1':
        if (etape2.capacite) caractList.push({ label: 'Capacité', valeur: `${etape2.capacite} kg` });
        if (etape2.hauteur) caractList.push({ label: 'Hauteur', valeur: `${etape2.hauteur} m` });
        break;
      default:
        if (etape2.capacite) caractList.push({ label: 'Capacité / CMU', valeur: `${etape2.capacite} kg` });
        break;
    }

    if (codeAnnexe !== 'B5') {
      const energies = getEnergies();
      if (energies) caractList.push({ label: 'Énergies employées', valeur: energies });
    }

    const equipements = formatEquipements(etape2);
    if (equipements) caractList.push({ label: 'Équipements', valeur: equipements });
    return caractList;
  };

  const caracteristiques = buildCaracteristiques();
  const nomClient = c.entreprise || c.nom || `${c.prenom || ''} ${c.nom || ''}`.trim();

  return (
    <div style={styles.page} className="pdf-page">
      <div style={styles.headerRow}>
        <div style={styles.logoWrap}>
          {p.company_logo_url && <img src={p.company_logo_url} alt="Logo" style={styles.logo} />}
        </div>
        <div style={styles.banner}>
          <div style={styles.bannerTitle}>Vérification générale périodique</div>
          <div style={styles.bannerText}><strong>Client : {nomClient}</strong></div>
          <div style={styles.bannerText}>{c.adresse}</div>
          <div style={styles.bannerText}>{c.code_postal} {c.ville}</div>
          <div style={{ ...styles.bannerText, marginTop: '6px' }}>
            <strong>Rapport de vérification : {r.numero_rapport}</strong>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '18px' }}>
        {caracteristiques.length > 0 && (
          <div style={styles.sectionBox}>
            <div style={styles.sectionHeader}>CARACTÉRISTIQUES TECHNIQUES</div>
            <table style={styles.table}>
              <tbody>
                {caracteristiques.map((caract, index) => (
                  <tr key={index}>
                    <td style={{ ...styles.td, ...styles.rowLabel }}>{caract.label} :</td>
                    <td style={{ ...styles.td, ...styles.rowValue }}>{caract.valeur}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {etape2.technologie_mecanisme && (
          <table style={styles.subBox}>
            <tbody>
              <tr>
                <td style={{ ...styles.td, ...styles.rowLabel }}>Technologie du mécanisme de levage :</td>
                <td style={{ ...styles.td, ...styles.rowValue }}>{etape2.technologie_mecanisme}</td>
              </tr>
            </tbody>
          </table>
        )}

        <table style={{ ...styles.table, border: '2px solid #000', marginBottom: '18px' }}>
          <thead>
            <tr style={{ background: '#f3f4f6' }}>
              <th style={styles.th}>DOCUMENTATION</th>
              <th style={{ ...styles.th, width: '120px' }}>Présenté(e)</th>
              <th style={{ ...styles.th, width: '120px' }}>Non Présenté(e)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={styles.td}>Notice d'utilisation</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{documentsData.notice_utilisation === 'presente' && '✔'}</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{(documentsData.notice_utilisation === 'non_presente' || !documentsData.notice_utilisation) && '✔'}</td>
            </tr>
            <tr>
              <td style={styles.td}>Certificat CE ou déclaration de conformité</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{documentsData.certificat_ce === 'presente' && '✔'}</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{(documentsData.certificat_ce === 'non_presente' || !documentsData.certificat_ce) && '✔'}</td>
            </tr>
            <tr>
              <td style={styles.td}>Carnet de maintenance</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{documentsData.carnet_maintenance === 'presente' && '✔'}</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{(documentsData.carnet_maintenance === 'non_presente' || !documentsData.carnet_maintenance) && '✔'}</td>
            </tr>
            <tr>
              <td style={styles.td}>Précédent rapport</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{documentsData.precedent_rapport === 'presente' && '✔'}</td>
              <td style={{ ...styles.td, textAlign: 'center' }}>{(documentsData.precedent_rapport === 'non_presente' || !documentsData.precedent_rapport) && '✔'}</td>
            </tr>
          </tbody>
        </table>

        {etape2.suspentes && (
          <div style={{ marginTop: '10px', padding: '10px', border: '1px solid #d1d5db', background: '#f9fafb' }}>
            <strong>Suspentes :</strong>
            <div style={{ whiteSpace: 'pre-line', marginTop: '6px' }}>{etape2.suspentes}</div>
          </div>
        )}
      </div>

      <div style={styles.footer}>
        <div style={styles.footerLine}>
          <div>{p.company_name} - {p.legal_form} au capital de {p.capital}</div>
          <div>N° Siret : {p.siret_number} - R.C.S. {p.rcs_number} - Code APE : {p.ape_code}</div>
          <div style={styles.footerRight}>Page 2 / 6</div>
        </div>
      </div>
    </div>
  );
}
